import React from 'react';
import { styled } from 'twin.macro';

const Box = styled.button`
  width: 100%;
  height: 47px;
  border-radius: 5px;
  background-color: #7687c2;
  padding: 10px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  img {
    height: 100%;
  }
  p {
    margin: 0;
    color: #ffffff;
    font-size: 13px;
  }
`;

const OSWCallout: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <Box onClick={onClick}>
    <img src="/img/wonder-hero-icon.svg" alt="" />
    <p>Wonder together about this song</p>
  </Box>
);

export default OSWCallout;
